import React, { useState, useEffect, useRef } from 'react';
import { BASE_URL } from '../../apiConfig';
import axios from 'axios';

function AssetHistoryReport() {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const searchInputRef = useRef(null);

   const handleSearch = async (e) => {
    if (e) e.preventDefault();
    if (!searchTerm.trim()) return;
    
    setLoading(true);
    try {
        const token = localStorage.getItem('token');
        
        // Usamos la BASE_URL de tu apiConfig
        const res = await axios.get(`${BASE_URL}/productos/movimientos/historial?search=${searchTerm}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        
        setReportData(res.data);
    } catch (err) {
        console.error("Error en la búsqueda", err);
        setReportData([]);
    } finally {
        setLoading(false);
        searchInputRef.current?.focus();
    }
};

    // FUNCIÓN PARA EXPORTAR A EXCEL (CSV)
    const exportToCSV = () => {
        if (reportData.length === 0) return;

        // Cabeceras del archivo
        const headers = ["Fecha,Producto,Codigo,Tipo,Cantidad,Motivo\n"];
        
        // Formatear filas
        const rows = reportData.map(mov => {
            const fecha = new Date(mov.fecha).toLocaleString().replace(/,/g, ""); // Limpiar comas para no romper el CSV
            return `${fecha},${mov.producto_nombre},${mov.producto_codigo},${mov.tipo},${mov.cantidad},${mov.razon || 'Sin referencia'}\n`;
        });

        const csvContent = headers.concat(rows).join("");
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `Historial_Inventario_${searchTerm}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    useEffect(() => {
        searchInputRef.current?.focus();
    }, []);

    return (
        <div className="form-container-responsive animate-fadeIn">
            <div className="mb-8 flex justify-between items-end">
                <div>
                    <span className="text-[10px] font-black text-gray-400 uppercase tracking-[0.3em] block mb-1">Auditoría de Inventario</span>
                    <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-3">
                        <i className="bi bi-journal-text text-amber-500"></i>
                        Historial de Productos
                    </h2>
                </div>
                
                {/* BOTÓN DE EXPORTAR - Solo se muestra si hay datos */}
                {reportData.length > 0 && (
                    <button 
                        onClick={exportToCSV}
                        className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-5 py-2.5 rounded-xl text-xs font-bold uppercase transition-all shadow-lg shadow-green-100"
                    >
                        <i className="bi bi-file-earmark-excel-fill text-lg"></i>
                        Exportar Excel
                    </button>
                )}
            </div>

            {/* BUSCADOR */}
            <div className="bg-white p-8 rounded-[2.5rem] shadow-sm border border-gray-100 mb-8">
                <div className="max-w-2xl mx-auto">
                    <label className="text-[10px] font-black text-amber-500 uppercase tracking-widest block mb-4 text-center">
                        Buscar por Nombre o Código de Producto
                    </label>
                    <form onSubmit={handleSearch} className="flex gap-3">
                        <div className="relative flex-1">
                            <i className="bi bi-search absolute left-5 top-1/2 -translate-y-1/2 text-gray-400"></i>
                            <input 
                                ref={searchInputRef}
                                type="text" 
                                className="input-modern !pl-14 !text-xl font-bold border-2 focus:border-amber-500 py-4 w-full"
                                placeholder="Ej: Tornillo hexagonal..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <button type="submit" className="bg-gray-900 text-white px-8 rounded-2xl font-black text-xs uppercase hover:bg-amber-500 transition-colors">
                            {loading ? '...' : 'Buscar'}
                        </button>
                    </form>
                </div>
            </div>

            {/* TABLA (Mismo código que tenías) */}
            <div className="bg-white rounded-[2.5rem] shadow-sm border border-gray-100 overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full text-left">
                        <thead>
                            <tr className="text-[11px] font-black text-gray-400 uppercase tracking-widest bg-gray-50/50">
                                <th className="px-8 py-5">Fecha / Hora</th>
                                <th className="px-8 py-5">Producto</th>
                                <th className="px-8 py-5 text-center">Tipo</th>
                                <th className="px-8 py-5 text-center">Cant.</th>
                                <th className="px-8 py-5">Motivo / Referencia</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                            {loading ? (
                                <tr><td colSpan="5" className="py-20 text-center text-gray-400">Consultando...</td></tr>
                            ) : reportData.length > 0 ? (
                                reportData.map((mov) => (
                                    <tr key={mov.id} className="hover:bg-amber-50/10 transition-colors">
                                        <td className="px-8 py-5 text-xs font-bold text-gray-600">{new Date(mov.fecha).toLocaleString()}</td>
                                        <td className="px-8 py-5">
                                            <div className="text-sm font-bold text-gray-800">{mov.producto_nombre}</div>
                                            <div className="text-[10px] font-mono text-amber-600">{mov.producto_codigo}</div>
                                        </td>
                                        <td className="px-8 py-5 text-center">
                                            <span className={`px-3 py-1 rounded-full text-[9px] font-black uppercase ${mov.tipo === 'entrada' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                                                {mov.tipo}
                                            </span>
                                        </td>
                                        <td className="px-8 py-5 text-center font-black text-gray-700">
                                            {mov.tipo === 'salida' ? '-' : '+'}{mov.cantidad}
                                        </td>
                                        <td className="px-8 py-5 text-xs text-gray-500 italic">{mov.razon || 'Sin referencia'}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan="5" className="px-8 py-20 text-center text-gray-300 italic">No hay resultados.</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default AssetHistoryReport;